<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="save" class="btn fixed_btn">
        Save
      </button>

      <div class="card">
        <editor v-model="term.html_format" />
        <div class='inputs'>
          <div class='btns left'>
            <button @click="save" class='btn round-btn'>Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from "@/components/CKEditor.vue";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;

export default {
  components: {
    editor: CKEditor,
  },
  data() {
    return {
      term: {
        html_format: null,
        text_format: null,
        created_at: Date.now(),
      },
    };
  },
  created() {
    this.getTerms();
  },
  watch: {
    term:{
      deep: true,
      handler(val){
        this.term.text_format = this.stripHTML(val.html_format) 
      }
    }
  },
  methods: {
    getTerms() {
      db.collection("user")
        .doc(this.user_doc.id)
        .collection("term")
        .get()
        .then((snapshot) => {
          this.term = !snapshot.empty
            ? Object.assign(
                { id: snapshot.docs[0].id },
                snapshot.docs[0].data()
              )
            : this.term;
        });
    },
    updateData(payload) {
      this.term.html_format = payload;
      this.term.text_format = this.stripHTML(payload);
    },
    stripHTML(html) {
      let doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },
    save() {
      let ref = this.term.id
        ? db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("term")
            .doc(this.term.id)
        : db
            .collection("user")
            .doc(this.user_doc.id)
            .collection("term")
            .doc();

      ref.set(this.term, { merge: true }).then(() => {
        Swal.fire("Your term content has been saved");
        this.getTerms();
      });
    },
  },
};
</script>

<style></style>
